import useOrganizationPeerSupportMembers from '@/hooks/peersupport/useOrganizationPeerSupportMembers';
import PeerSupportDirectoryCard from '@/modules/directory/cards/PeerSupportDirectoryCard';
import DirectoryPageTemplate from '@/modules/directory/DirectoryPageTemplate';
import { Text } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';

const PeerSupportDirectory = () => {
  const { isLoading, data, fetchNextPage, isFetchingNextPage, hasNextPage } = useOrganizationPeerSupportMembers(
    undefined,
    true,
  );

  return (
    <DirectoryPageTemplate
      title="Your Peer Support Team"
      isLoading={isLoading}
      isFetchingNextPage={isFetchingNextPage}
      hasNextPage={hasNextPage}
      onViewMoreClick={fetchNextPage}
    >
      {data?.length === 0 && <Text variant={'urbanistSemiBoldLarge'}>No Peer Support team members at the moment</Text>}
      {data?.map((peerSupport) => <PeerSupportDirectoryCard member={peerSupport} showStar key={peerSupport?.id} />)}
    </DirectoryPageTemplate>
  );
};

export const Route = createFileRoute('/_authenticated/_directory/_peer-support/directory/peer-support')({
  staticData: { title: 'Peer Support Directory' },
  component: PeerSupportDirectory,
});
